import React from "react";
import { useLocation, useRouteMatch } from "react-router-dom";
import { DesktopMenu } from "../../components/DesktopMenu";
import { getPageType } from "../../utils/PageTypeSelector";
import businessContent from "./content/business.json";
import developersContent from "./content/developers.json";
import personalContent from "./content/personal.json";

const PAGETYPE_CONTENTS = [
  {
    type: "personal",
    content: personalContent,
  },
  {
    type: "business",
    content: businessContent,
  },
  {
    type: "developers",
    content: developersContent,
  },
];

export const DesktopMenuContainer: React.FC = () => {
  const { path } = useRouteMatch();

  // Get menu content from page type
  const pageType = getPageType(useLocation().pathname);
  const content = PAGETYPE_CONTENTS.find(t => t.type === pageType)!!.content.menusConfig;

  return <DesktopMenu menu={content} currentPath={path} />;
};
